import { validateConsistent } from "./validateConsistent";
import { validateRange } from "./validateRange";
import { validateKeepRise } from "./validateKeepRise";
import { validatePreopen } from "./validatePreopen";

export function validateAdvancedOrderConfig(config) {
    if (!config) return "Missing advanced order configuration.";
    if (!config.side) return "Order side (BUY/SELL) is required.";
    if (!config.mode) return "Order mode is required.";

    // Generic safeguards (these exist on your config objects)
    if (config.singleLargestOrderValue !== undefined && config.singleLargestOrderValue !== null && config.singleLargestOrderValue !== "") {
        const v = Number(config.singleLargestOrderValue);
        if (!Number.isFinite(v) || v <= 0) return "Single largest order value must be > 0.";
    }

    // totalDurationHours already computed in builder; if provided must be >0
    if (config.totalDurationHours !== undefined && config.totalDurationHours !== null && config.totalDurationHours !== "") {
        const d = Number(config.totalDurationHours);
        if (!Number.isFinite(d) || d <= 0) return "Total duration hours must be > 0.";
    }

    switch (config.mode) {
        case "CONSISTENT": return validateConsistent(config);
        case "RANGE": return validateRange(config);
        case "KEEP_RISE": return validateKeepRise(config);
        case "PREOPEN": return validatePreopen(config);
        default: return "Invalid order mode.";
    }
}
